import { emailRegex } from '@wix/wix-js-validations';

const doesFieldHasValue = (value: string) => value && value.length > 0;

export const isValidEmail = (email: string): boolean => {
  return !!(
    doesFieldHasValue(email as string) && emailRegex.test(email as string)
  );
};
